export const translations = {
    it: {
        nav: { cart: "Carrello", menu: "Menu" },
        hero: {
            eyebrow: "Brand indipendente — Fatto a mano",
            ctaShop: "Acquista ora",
            ctaLookbook: "Lookbook",
            badge: "Collezione 01",
        },
        strip: { items: ["Fatto a mano", "Pezzi unici, piccole quantità"] },
        walkers: { caption: "La community Seva in cammino" },
        statement: {
            eyebrow: "La filosofia Seva",
            words: ["Fatto", "da", "una", "persona.", "Fatto", "per", "le", "persone."],
        },
        categories: { title: "Le categorie", index: "01 / Esplora", shop: "Shop", labels: { giacche: "GIACCHE", hoodies: "FELPE", completi: "COMPLETI", top: "TOP" } },
        featured: { title: "Ultimi arrivi", viewAll: "Vedi tutto" },
        product: {
            quickView: "Vista rapida",
            categories: { tshirts: "T-Shirt", hoodies: "Felpa", giacche: "Giacca", sweatpants: "Sweatpants", completi: "Completo", top: "Top" },
            backToShop: "Torna allo shop",
            fabric: "Tessuto",
            shipping: "Spedizione",
            alsoLike: "Potrebbe piacerti anche",
            handmadeNote: "Fatto a mano nel laboratorio Seva — pezzi unici, mai uguali.",
            customCta: "Vuoi un capo su commissione?",
            customCtaLink: "Scrivici via email o Instagram",
            soldOut: "Sold out",
            soldOutNote: "Esaurito — pezzo unico, non tornerà. Vuoi qualcosa di simile? Scrivici per un capo su commissione.",
        },
        quickview: {
            brand: "Seva — Fatto a mano",
            size: "Taglia",
            onlySize: "solo {size} disponibile",
            add: "Aggiungi al carrello",
            selectSize: "Seleziona una taglia",
            added: "aggiunto al carrello",
        },
        cart: {
            title: "Carrello",
            empty: "Il carrello è vuoto",
            continue: "Continua lo shopping",
            size: "Taglia",
            subtotal: "Subtotale",
            note: "Spedizione e tasse calcolate al checkout.",
            checkout: "Vai al pagamento",
            redirecting: "Reindirizzamento...",
            error: "Errore durante il checkout. Riprova.",
        },
        manifesto: {
            eyebrow: "Dal laboratorio",
            lines: ["Ogni capo è disegnato,", "tagliato e cucito a mano.", "In laboratorio,", "uno alla volta."],
            quote: "«Per sentirsi meglio, per sentirsi parte di qualcosa.»",
            body: "Seva è un brand indipendente: pochi capi, fatti a mano con cura. Quando un pezzo finisce, non torna — chi lo indossa sa che è unico.",
        },
        custom: {
            eyebrow: "Pezzi unici, solo per te",
            title: "Su commissione",
            body: "Hai un'idea, un tessuto, una forma che non trovi da nessuna parte? Raccontala a Seva: ogni capo su commissione viene disegnato e cucito a mano in laboratorio, in un pezzo unico fatto per te.",
            checklistTitle: "Per essere più veloci, scrivici subito:",
            checklist: [
                "Entro quando ti serve il capo finito",
                "Che capo vuoi: giacca, felpa, pantaloni...",
                "La tua taglia o le tue misure",
                "Tessuti e colori che immagini",
                "Il tuo budget indicativo",
                "La città per spedizione o ritiro",
            ],
            emailLabel: "Scrivici su Email",
            igLabel: "Scrivici su Instagram",
            note: "Ti rispondo entro pochi giorni con tempi, tessuti disponibili e preventivo.",
            worksTitle: "Alcuni lavori su commissione",
        },
        lab: {
            title: "In laboratorio",
        },
        footer: {
            tagline: "Fatto a mano. Urban. Sartoriale. Unisciti alla community per drop esclusivi e storie dal laboratorio.",
            instagram: "Seguici su Instagram",
            newsletter: "Newsletter",
            placeholder: "La tua email",
            subscribe: "Iscriviti",
            rights: "Tutti i diritti riservati",
            madeIn: "Fatto a mano",
            invalidEmail: "Inserisci un'email valida",
            subscribed: "Iscrizione completata. Benvenuto nella famiglia Seva.",
            subscribeError: "Errore durante l'iscrizione. Riprova.",
        },
        shop: {
            title: "Shop",
            subtitle: "Ogni capo è fatto a mano nel nostro laboratorio. Piccole quantità, mai uguali.",
            filters: { all: "TUTTI", giacche: "GIACCHE", hoodies: "FELPE", completi: "COMPLETI", top: "TOP" },
            emptyTitle: "In arrivo presto",
            emptyBody: "Stiamo cucendo i prossimi capi di questa categoria. Torna a trovarci.",
        },
        lookbook: {
            title: "Lookbook",
            emptyTitle: "In arrivo presto",
            emptyBody: "Stiamo preparando gli scatti della collezione. Intanto puoi vedere i capi disponibili nello shop.",
            shopNow: "Acquista il capo",
        },
        about: {
            title: "Il laboratorio",
            tagline: "«Per sentirsi meglio, per sentirsi parte di qualcosa.»",
            body: "Seva nasce in un piccolo laboratorio: macchine da cucire, tessuti scelti uno a uno e lavoro artigianale. La produzione è in piccole quantità: quando un capo finisce, non torna. Chi lo indossa sa che è stato fatto per durare.",
            values: [
                { title: "Fatto a mano", text: "Ogni capo è tagliato e cucito a mano in laboratorio. Nessuna catena di montaggio." },
                { title: "Unisex", text: "Capi pensati per tutti: uomo e donna, senza distinzioni. Solo vestibilità e carattere." },
                { title: "Urban sartoriale", text: "Lo stile della strada incontra la cura della sartoria. Casual chic che dura nel tempo." },
            ],
            ctaTitle: "Entra nella community",
            ctaShop: "Acquista la collezione",
        },
        payment: {
            loadingTitle: "Conferma in corso...",
            loadingBody: "Stiamo verificando il tuo pagamento.",
            paidTitle: "Ordine confermato",
            paidBody: "Grazie per aver scelto Seva. Il tuo capo è già pronto: lo preparo per la spedizione e riceverai presto una email di conferma.",
            continue: "Continua lo shopping",
            errorTitle: "Qualcosa non va",
            errorBody: "Non riusciamo a confermare il pagamento. Se hai completato l'ordine, controlla la tua email o contattaci su Instagram.",
            backHome: "Torna alla home",
            cancelTitle: "Pagamento annullato",
            cancelBody: "Nessun addebito è stato effettuato. I tuoi capi sono ancora nel carrello, pronti quando vuoi.",
            backToCart: "Torna al carrello",
            shop: "Shop",
        },
    },
    en: {
        nav: { cart: "Cart", menu: "Menu" },
        hero: {
            eyebrow: "Independent brand — Handmade",
            ctaShop: "Shop now",
            ctaLookbook: "Lookbook",
            badge: "Collection 01",
        },
        strip: { items: ["Handmade", "One-of-a-kind, small batches"] },
        walkers: { caption: "The Seva community on the move" },
        statement: {
            eyebrow: "The Seva philosophy",
            words: ["Made", "by", "one", "person.", "Made", "for", "people."],
        },
        categories: { title: "Categories", index: "01 / Explore", shop: "Shop", labels: { giacche: "JACKETS", hoodies: "HOODIES", completi: "CO-ORDS", top: "TOPS" } },
        featured: { title: "Latest drops", viewAll: "View all" },
        product: {
            quickView: "Quick view",
            categories: { tshirts: "T-Shirt", hoodies: "Hoodie", giacche: "Jacket", sweatpants: "Sweatpants", completi: "Co-ord set", top: "Top" },
            backToShop: "Back to shop",
            fabric: "Fabric",
            shipping: "Shipping",
            alsoLike: "You might also like",
            handmadeNote: "Handmade in the Seva workshop — one-of-a-kind pieces, never the same.",
            customCta: "Want a custom-made piece?",
            customCtaLink: "Write to us by email or Instagram",
            soldOut: "Sold out",
            soldOutNote: "Sold out — one-of-a-kind piece, it won't be back. Want something similar? Write to us for a custom order.",
        },
        quickview: {
            brand: "Seva — Handmade",
            size: "Size",
            onlySize: "only {size} available",
            add: "Add to cart",
            selectSize: "Select a size",
            added: "added to cart",
        },
        cart: {
            title: "Cart",
            empty: "Your cart is empty",
            continue: "Continue shopping",
            size: "Size",
            subtotal: "Subtotal",
            note: "Shipping and taxes calculated at checkout.",
            checkout: "Go to checkout",
            redirecting: "Redirecting...",
            error: "Checkout error. Please try again.",
        },
        manifesto: {
            eyebrow: "From the workshop",
            lines: ["Every garment is designed,", "cut and sewn by hand.", "In the workshop —", "one at a time."],
            quote: "\u201cTo feel better, to feel part of something.\u201d",
            body: "Seva is an independent brand: few garments, handmade with care. When a piece is gone, it's gone — whoever wears it knows it's one of a kind.",
        },
        custom: {
            eyebrow: "One-of-a-kind pieces, just for you",
            title: "Made to order",
            body: "Have an idea, a fabric, a shape you can't find anywhere? Tell Seva: every made-to-order garment is designed and sewn by hand in the workshop, as a unique piece made for you.",
            checklistTitle: "To speed things up, tell us right away:",
            checklist: [
                "When you need the finished garment",
                "What garment you want: jacket, hoodie, trousers...",
                "Your size or measurements",
                "Fabrics and colours you have in mind",
                "Your indicative budget",
                "Your city for shipping or pickup",
            ],
            emailLabel: "Write to us by Email",
            igLabel: "Write to us on Instagram",
            note: "I reply within a few days with timing, available fabrics and a quote.",
            worksTitle: "Some custom commissions",
        },
        lab: {
            title: "In the workshop",
        },
        footer: {
            tagline: "Handmade. Urban. Tailored. Join the community for exclusive drops and stories from the workshop.",
            instagram: "Follow us on Instagram",
            newsletter: "Newsletter",
            placeholder: "Your email",
            subscribe: "Subscribe",
            rights: "All rights reserved",
            madeIn: "Handmade",
            invalidEmail: "Please enter a valid email",
            subscribed: "Subscription complete. Welcome to the Seva family.",
            subscribeError: "Subscription error. Please try again.",
        },
        shop: {
            title: "Shop",
            subtitle: "Every garment is handmade in our workshop. Small batches, never the same.",
            filters: { all: "ALL", giacche: "JACKETS", hoodies: "HOODIES", completi: "CO-ORDS", top: "TOPS" },
            emptyTitle: "Coming soon",
            emptyBody: "We're sewing the next pieces for this category. Check back soon.",
        },
        lookbook: {
            title: "Lookbook",
            emptyTitle: "Coming soon",
            emptyBody: "We're preparing the collection shots. In the meantime, you can see the available garments in the shop.",
            shopNow: "Shop the piece",
        },
        about: {
            title: "The workshop",
            tagline: "\u201cTo feel better, to feel part of something.\u201d",
            body: "Seva is born in a small workshop: sewing machines, fabrics chosen one by one, and artisan work. Production runs in small batches: when a piece sells out, it doesn't come back. Whoever wears it knows it was made to last.",
            values: [
                { title: "Handmade", text: "Every garment is cut and sewn by hand in the workshop. No assembly line." },
                { title: "Unisex", text: "Garments designed for everyone: men and women, no distinctions. Just fit and character." },
                { title: "Urban tailoring", text: "Street style meets tailoring care. Casual chic built to last." },
            ],
            ctaTitle: "Join the community",
            ctaShop: "Shop the collection",
        },
        payment: {
            loadingTitle: "Confirming...",
            loadingBody: "We're verifying your payment.",
            paidTitle: "Order confirmed",
            paidBody: "Thank you for choosing Seva. Your garment is ready: I'll get it packed for shipping and you'll receive a confirmation email soon.",
            continue: "Continue shopping",
            errorTitle: "Something went wrong",
            errorBody: "We can't confirm your payment. If you completed the order, check your email or contact us on Instagram.",
            backHome: "Back to home",
            cancelTitle: "Payment cancelled",
            cancelBody: "No charge was made. Your garments are still in the cart, ready whenever you are.",
            backToCart: "Back to cart",
            shop: "Shop",
        },
    },
};
